import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PullToRefreshService {
  // Web: platforms (Chrome/Safari mobile, desktop browsers) handle pull-to-refresh
  // and the beforeunload confirm dialog natively. The native build swaps this for
  // pull-to-refresh.service.native.ts via angular.json fileReplacements.
  init(): void { /* no-op */ }
}
